/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Opciones de trimestres para el filtro
 */
export const QUARTER_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: '1', label: '1 (Enero, Febrero, Marzo)' },
  { value: '2', label: '2 (Abril, Mayo, Junio)' },
  { value: '3', label: '3 (Julio, Agosto, Septiembre)' },
  { value: '4', label: '4 (Octubre, Noviembre, Diciembre)' },
];

/**
 * Opciones de meses para el filtro
 */
export const MONTH_OPTIONS = [
  { value: '1', label: 'Enero' },
  { value: '2', label: 'Febrero' },
  { value: '3', label: 'Marzo' },
  { value: '4', label: 'Abril' },
  { value: '5', label: 'Mayo' },
  { value: '6', label: 'Junio' },
  { value: '7', label: 'Julio' },
  { value: '8', label: 'Agosto' },
  { value: '9', label: 'Septiembre' },
  { value: '10', label: 'Octubre' },
  { value: '11', label: 'Noviembre' },
  { value: '12', label: 'Diciembre' },
];

/**
 * Tipos de período de tiempo
 */
export const TIME_PERIOD_TYPES = {
  QUARTER: 'quarter',
  MONTH: 'month',
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    EMAIL_SENT: 'Email enviado exitosamente',
    BULK_EMAILS_SENT: 'Emails enviados exitosamente',
  },
  ERROR: {
    EMAIL_SEND_FAILED: 'Error al enviar el email',
    BULK_EMAILS_SEND_FAILED: 'Error al enviar los emails',
    INVALID_EMAIL: 'Email inválido',
    NO_SUBSCRIBERS_SELECTED: 'No hay suscriptores seleccionados',
  },
  INFO: {
    LOADING_SUBSCRIBERS: 'Cargando suscriptores...',
    NO_SUBSCRIBERS_FOUND: 'No se encontraron suscriptores',
    ALL_SUBSCRIBERS_SELECTED: 'Todos los suscriptores han sido seleccionados',
  },
  CONFIRMATION: {
    SEND_EMAIL: '¿Enviar email?',
    SEND_BULK_EMAILS: '¿Enviar emails seleccionados?',
    VERIFICATION_COMPLETE: 'Todos los ítems han sido verificados. ¿Enviar los seleccionados?',
  },
};

/**
 * Configuración de email por defecto
 */
export const DEFAULT_EMAIL_CONFIG = {
  FROM: 'administracion@constructoracolonial.com.ar',
  DEFAULT_TO: 'administracion@constructoracolonial.com.ar',
  ATTACHMENT_NAME: 'NroOrden1-Año2023-Grupo0.pdf',
};

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  contractNumber: { width: { xs: '15%', md: '10%' } },
  subscribers: { width: { xs: '25%', md: '20%' } },
  coupons: { width: { xs: '40%', md: '50%' } },
  sendEmail: { width: { xs: '10%', md: '10%' } },
  select: { width: { xs: '10%', md: '10%' } },
};

/**
 * Estados de procesamiento
 */
export const PROCESSING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

/**
 * Breakpoints para responsividad
 */
export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};

/**
 * Año inicial para el selector de años
 */
export const START_YEAR = 1990;
